export default __webpack_public_path__ + "static/media/abhay.54db06d7.png";